const NS = 'CourseCarouselBlock';
const CLS = 'courseCarouselBlock';

import Swiper from 'swiper/swiper-bundle.js';

export class CourseCarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$swiper = this.$element.find(`.${CLS}-swiper`);
		this.$buttonNext = this.$element.find(`.${CLS}-swiper-button-next`);
		this.$buttonPrev = this.$element.find(`.${CLS}-swiper-button-prev`);

		const swiper = new Swiper(this.$swiper[0], {
			speed: 700,
			spaceBetween: 0,
			slidesPerView: 'auto', // scroll 3 at a time instead of 1
			slidesPerGroupAuto: true, // scroll 3 at a time instead of 1
			autoHeight: true,
			navigation: {
				nextEl: this.$buttonNext[0],
				prevEl: this.$buttonPrev[0]
			}
		});

		this.initAnimateScrollReveal(this, CLS);

		// this.element = element;
		// this.$element = $(element);

		// this.$elementInner = this.$element.find(`.${CLS}-inner`);
		// this.$carouselItems = this.$element.find(`.${CLS}-item`);
		// this.$carouselSlider = this.$element.find(`.${CLS}-slider`);
		// this.$carouselSlider.slick({
		// 	dots: true,
		// 	dotsClass: `slick-dots`,
		// 	appendArrows: this.$elementInner,
		// 	appendDots: this.$elementInner,
		// 	nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-right"></i></button>`,
		// 	prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-left"></i></button>`,
		// 	infinite: false,
		// 	slidesToShow: 3,
		// 	slidesToScroll: 1,
		// 	mobileFirst: false,
		// 	cssEase: 'ease-in-out',
		// 	useTransform: true,
		// 	responsive: [
		// 		{
		// 			breakpoint: 992,
		// 			settings: {
		// 				centerPadding: '60px',
		// 				slidesToShow: 2,
		// 				slidesToScroll: 1
		// 			}
		// 		},
		// 		{
		// 			breakpoint: 600,
		// 			settings: {
		// 				centerMode: true,
		// 				centerPadding: '0',
		// 				slidesToShow: 1,
		// 				slidesToScroll: 1
		// 			}
		// 		}
		// 	]
		// });

		// this.$carouselItems.css({ opacity: 1 });

		// this.adjustArrowVisibility();

		// $(window).resize(_.debounce(() => {
		// 	this.adjustArrowVisibility();
		// }, 50, { trailing: true }));
	}

	// adjustArrowVisibility() {
	// 	let $arrows = this.$element.find(`.slick-arrow`);
	// 	if(!($arrows && $arrows.length > 0)) {
	// 		return;
	// 	}

	// 	let previousArrow = this.$element.find(`.slick-arrow--previous`);
	// 	let nextArrow = this.$element.find(`.slick-arrow--next`);

	// 	previousArrow.css({
	// 		visibility: Math.floor(previousArrow.offset().left) < 0 ? 'hidden' : 'visible'
	// 	});

	// 	nextArrow.css({
	// 		visibility: (Math.ceil(nextArrow.offset().left + nextArrow.width()) + 1) >= this.getContainerWidth() ? 'hidden' : 'visible'
	// 	});
	// }

	// getContainerWidth() {
	// 	let $tplContent = $('.tpl-content');
	// 	if($tplContent && $tplContent.length > 0) {
	// 		return $tplContent.width();
	// 	}
	// 	return $(window).width();
	// }
}

